export default {
    carousel: [],
    error: false,
    errorMessage: ''
  }